import SelectList from "../../assets/SelectList";
import React from "react";
import {RichCell, Switch} from "@vkontakte/vkui";
import StandCollectionsManagers from "../../api/references/managers/standcollectionsManagers";
import StandKitsManagers from "../../api/references/managers/standkitsManagers";
import withOffline from "../../components/withOffline";

/**
 * Коллекции стенда в мониторинге с группировкой по комплектациям (ТЗ 241).
 * Строки: комплектация (isKit) -> её коллекции (isChild) -> коллекции вне комплектаций.
 * Тумблер комплектации переключает все её коллекции.
 */
class StandCollectionsSelectList extends SelectList {

    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            current_collection: {}
        }
    }

    isChecked = (collectionId) => {
        const {current_item} = this.props
        return !!(current_item && current_item.collections && current_item.collections[collectionId])
    }

    getItems(search_ = '', append = false, page = 1) {
        const search = String(search_ ? search_ : (this.state.search || '')).trim().toLowerCase()
        const matches = (title) => !search || String(title || '').toLowerCase().includes(search)

        // Коллекций у стенда немного: грузим все одной страницей, чтобы группировка не рвалась по страницам.
        const params = {
            show_deleted: false,
            isOffline: this.props.isOffline,
            search: '',
            page: 1,
            epp: 500,
            ...this.props.params
        }

        this.setState({loading: true})
        StandKitsManagers.getList(params).then(async (kitsRes) => {
            const kits = (kitsRes.data.results || [])
                .filter(k => Array.isArray(k.collection_ids) && k.collection_ids.length > 0)
            const ids = [...new Set(kits.flatMap(kit => kit.collection_ids.map(id => Number(id))))]
            if (ids.length === 0) {
                this.setState({items: [], loading: false, cnt_items: 0, totalPages: 1, page: 1})
                return
            }
            const collRes = await StandCollectionsManagers.getList({
                ...params,
                stand_id: undefined,
                ids: ids.join(','),
                epp: 500,
            })
            const byId = {}
            ;(collRes.data.results || []).forEach(el => {
                byId[String(el.id)] = {...el, name: el.title, uid: el.id}
            })

            const items = []
            kits.forEach(kit => {
                const children = kit.collection_ids
                    .map(id => byId[String(id)])
                    .filter(Boolean)
                if (children.length === 0) return

                const kitMatches = matches(kit.title)
                const visibleChildren = children.filter(c => kitMatches || matches(c.title))
                if (visibleChildren.length === 0) return

                const childItems = visibleChildren.map(c => ({
                    ...c,
                    checked: this.isChecked(c.id),
                    isChild: children.length > 1,
                    kit_id: kit.id,
                    kit_version_id: kit.version_id,
                    kit_title: kit.title,
                }))
                if (children.length === 1) {
                    items.push(childItems[0])
                    return
                }
                items.push({
                    isKit: true,
                    id: 'kit_' + kit.id,
                    uid: 'kit_' + kit.id,
                    kit_id: kit.id,
                    name: kit.title,
                    descr: kit.serial_number ? `Комплектация, серийный номер ${kit.serial_number}` : 'Комплектация',
                    checked: children.every(c => this.isChecked(c.id)),
                })
                items.push(...childItems)
            })

            this.setState({
                items,
                loading: false,
                cnt_items: items.length,
                totalPages: 1,
                page: 1,
            })
        }).catch(() => this.setState({loading: false}))
    }

    selectObject(index) {
        const items = [...this.state.items]
        const item = items[index]
        if (!item) return

        if (item.isKit) {
            const next = !item.checked
            item.checked = next
            items.forEach((el, i) => {
                if (el.isChild && el.kit_id === item.kit_id && !!el.checked !== next) {
                    el.checked = next
                    window.postMessage({type: 'selectListObject', item: el, index: i})
                }
            })
            this.setState({items})
            return
        }

        item.checked = !item.checked
        if (item.isChild) {
            const kitRow = items.find(el => el.isKit && el.kit_id === item.kit_id)
            if (kitRow) {
                kitRow.checked = items
                    .filter(el => el.isChild && el.kit_id === item.kit_id)
                    .every(el => el.checked)
            }
        }
        this.setState({items})
        window.postMessage({type: 'selectListObject', item, index})
    }

    renderRow(item, index) {
        return <RichCell key={'select_obj' + index}
                         onClick={() => this.selectObject(index)} multiline
                         style={{
                             paddingLeft: item.isChild ? '40px' : undefined,
                             fontWeight: item.isKit ? 700 : 400,
                             backgroundColor: item.isKit ? 'rgba(210, 231, 226, 0.35)' : 'inherit',
                         }}
                         subhead={item.descr}
                         after={<Switch onClick={() => this.selectObject(index)} checked={!!item.checked}/>}
        >
            {item.name}
        </RichCell>
    }
}

export default withOffline(StandCollectionsSelectList)
